import Lesson from "../page/lesson/Lesson";

export default function LessonHOC({ ...props }) {
  return (
    <>
      <Lesson {...props} />
    </>
  );
}
